

import { useQuery } from "@tanstack/react-query";
import type { StoreSubscriptionLedgerResponse } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreSubscriptionLedgerQueryParams = {
  storeId: string;
};

export function useStoreSubscriptionLedgerQuery({
  storeId,
}: UseStoreSubscriptionLedgerQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeSubscriptionLedger(storeId),
    queryFn: () =>
      apiJsonClient<StoreSubscriptionLedgerResponse>(
        endpoints.admin.storeSubscriptionScheduleLedger(storeId),
      ),
    enabled: storeId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
